<script>
	import { styles } from '../scripts/styles'

	export let column = '200px'
	export let width = '100%'
	export let height = '100%'
	export let backgroundColor = 'transparent'
	export let alignHorizontal = 'center'
	export let alignVertical = 'center'
	export let padding = '0%'
	export let scroll = 'none'
</script>

<!-- two columns layout  -->
<div
	use:styles={{ column, width, height, backgroundColor, alignHorizontal, alignVertical, padding, scroll }}
	class="container"
>
	<slot name="column1" />
	<slot name="column2" />
</div>

<style>
	.container {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(var(--column), 1fr));
		justify-content: var(--alignHorizontal);
		align-items: var(--alignVertical);
		background-color: var(--backgroundColor);
		grid-gap: 2vw;
		width: var(--width);
		padding: var(--padding);
		height: var(--height);
		overflow-y: var(--scroll);
	}
</style>
